// İSG uzmanı portalı — Güvenlik / Saha Geçişi erişim kapısı (route guard UX).
// `VisitorsGate.tsx`'in birebir deseni.
//
// Asıl yetki backend'dedir (`[ModuleAction("security", …)]`); bu kapı yalnız UX'tir:
// erişim sondasının (useSecurityAccess) sonucuna göre Güvenlik masasını, 403 sayfasını veya
// "kullanılamıyor" durumunu gösterir. `granted` → `SecurityDeskPage` (saha listesi hazır).

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { ShieldAlert, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSecurityAccess } from '../../lib/securityAccess';
import { SecurityDeskPage } from './SecurityDeskPage';

export function SecurityGate() {
  const { t } = useTranslation();
  const access = useSecurityAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('security.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <ShieldAlert className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('security.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('security.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('security.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('security.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('security.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('security.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <SecurityDeskPage sites={access.sites} />;
}
